// extracted by mini-css-extract-plugin
module.exports = {"main-sidebar":"style_main-sidebar__37M2R","open":"style_open__TXq0d","menu-title":"style_menu-title__3Ftpb","overlay":"style_overlay__L4KGu","show":"style_show__UJ67j"};